// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from 'firebase/database';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCYkCr2y2X5e7rf3K_GSpG-26HUHiP7rmE",
  authDomain: "portfolio-mars.firebaseapp.com",
  databaseURL: "https://portfolio-mars-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "portfolio-mars",
  storageBucket: "portfolio-mars.appspot.com",
  messagingSenderId: "905681796605",
  appId: "1:905681796605:web:6b7a92182069e6bff9ad94"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app)